export default "__VITE_ASSET__Db242MFW__"